/* src/app/submission-view/submission-view.component.css */
.link {
  font-size: 30px;
  display: inline-block;
  margin-top: 15px;
  margin-bottom: 10px;
  margin-right: 10px;
}
.field-label {
  margin-right: 5px;
}
.field-label-table {
  margin-right: 5px;
  margin-top: 0px;
  margin-bottom: 0px;
}
.section-line {
  border-bottom: 1px solid #D5D5D5;
  margin-bottom: 7px;
}
.indent-1 {
  margin-left: 20px;
}
.section-label {
  font-size: 1.2em;
  margin-top: 10px;
}
.field-td {
  text-align: left;
  height: 25px;
}
.dl-link {
  color: #337ab7;
}
.field-pre {
  display: block;
  white-space: pre-wrap;
  margin-top: 0px;
  margin-bottom: 8px;
}
.map-div {
  height: 600px;
  width: 680px;
}
.grid-align-left {
  text-align: left;
}
.form-btn {
  margin-bottom: 12px;
}
::ng-deep .p-table .p-table-thead > tr > th {
  background-color: #f8f9fa !important;
  border: 1px solid #dee2e6 !important;
  padding: 12px 8px !important;
  font-weight: 600 !important;
  color: #212529 !important;
  font-size: 0.95rem !important;
}
::ng-deep .p-table .p-table-tbody > tr > td {
  border: 1px solid #dee2e6 !important;
  padding: 10px 8px !important;
}
::ng-deep .p-table .p-table-tbody > tr:hover {
  background-color: #f8f9fa !important;
}
::ng-deep .p-table {
  border: 1px solid #dee2e6 !important;
}
/*# sourceMappingURL=submission-view.component.css.map */
